import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
    name: 'naDecimal'
})
export class NaDecimalPipe extends DecimalPipe implements PipeTransform {
    constructor(@Inject(LOCALE_ID) locale: string) {
        super(locale);
    }
    transform(
        value: number | string,
        digitsInfo?: string,
        locale?: string,
        nullValue: string = 'n/a'
    ): any {
        return value == null ? nullValue : super.transform(value, digitsInfo, locale);
    }
}
